<ng-container *ngIf="safeLink">
  <div class="core-iframe-wrapper">
    <iframe [src]="safeLink" class="h-100 w-100"></iframe>
    <div class="footer">
      <button class="eidos-button eidos-button-outlined eidos-button-normal eidos-button" (click)="onCloseModalClick()">CLOSE</button>
    </div>
  </div>
</ng-container>
